// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bc9b136b","221":"1ae449b9","453":"64aababc","473":"5c98bc5e","728":"ec615d86"}[chunkId] + ".chunk.js";
};